
export const contactusFields = [
    { label: "Heading *", type: "text", name: "name", placeHolder: "Contactus Name", class: "", value: "", input: "text", validation: "required" },
    { label: "Status *", type: "text", name: "status", placeHolder: "Status", class: "", value: [{ id: "1", name: "Active" }], input: "dropdown", validation: "" },
    { label: "Content ", type: "text", name: "content", placeHolder: "Content", class: "", value: "", input: "cke", validation: "" }];